import type { GameState, SaveData } from "./types";

export function calculateStars(state: GameState, won: boolean): number {
  if (!won) return 0;
  let stars = 1;
  if (state.movesRemaining >= state.mission.targetMoves) stars++;
  if ((state.mission.avoidTraps && state.trapsTriggered === 0) ||
      (!state.mission.avoidTraps && state.score >= state.mission.targetScore)) stars++;
  return stars;
}

export function isLevelUnlocked(save: SaveData, level: number): boolean {
  return level === 1 || level <= save.progression.campaignLevel;
}

export function missionComplete(state: GameState): boolean {
  return state.treasuresCollected >= state.treasureGoal &&
    state.rewards.relicFragments >= state.objective.relicFragmentsRequired &&
    Number(Boolean(state.lastSecretRoom)) >= state.objective.secretRoomsRequired;
}

export function milestoneFragments(level: number, alreadyClaimed: number[]): number {
  return (level === 5 || level === 10) && !alreadyClaimed.includes(level) ? 2 : 0;
}

export function xpForLevel(level: number): number {
  return level <= 1 ? 0 : Math.floor(100 * Math.pow(level - 1, 1.5));
}

export function explorerLevel(xp: number): number {
  let level = 1;
  while (xp >= xpForLevel(level + 1)) level++;
  return level;
}
